module.exports = __webpack_public_path__ + "img/lanc2.5b633768.jpg";